import { Grid, Icon, Loader, Table } from "semantic-ui-react";
import { ValidOpenstackResource } from "../../../../types";
import useNetworkSubnets from "./hooks/useNetworkSubnets";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toggleSlidingMenu } from "../../../../../actions/toggleSlidingMenu";
import SubnetItem from "./SubnetItem";

type ConnectedSubnetsProps = {
  network: ValidOpenstackResource;
};

const ConnectedSubnets = ({ network }: ConnectedSubnetsProps) => {
  const dispatch = useDispatch();

  const { isLoading, subnets } = useNetworkSubnets(network);

  const onCreateSubnet = useCallback(() => {
    return dispatch(
      toggleSlidingMenu("create", "Subnet", { region: network.region }),
    );
  }, [dispatch, network]);

  return (
    <Grid.Row className="separator animateDown">
      <Grid.Column
        textAlign="left"
        width={8}
        className="default-height flex vcenter"
      >
        <h5>
          <Icon name="sitemap" /> Subnets
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        {!isLoading && subnets.length === 0 && "No Subnets for this network"}
        {isLoading && (
          <div className="loader-wrapper">
            <Loader size="mini" active className="one-liner ">
              Fetching Subnets list...
            </Loader>
          </div>
        )}
      </Grid.Column>

      <Grid.Column textAlign="right" width={16}>
        {subnets.length > 0 && (
          <div className="curve-table">
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>id</Table.HeaderCell>
                  <Table.HeaderCell>gateway_ip</Table.HeaderCell>
                  <Table.HeaderCell>cidr</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {subnets.map((subnet, key) => (
                  <SubnetItem key={key} subnet={subnet} />
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </Grid.Column>
      <Grid.Column textAlign="right" width={16}>
        <button
          className="float-right button button--green"
          onClick={onCreateSubnet}
        >
          <span>Create new Subnet</span>
        </button>
      </Grid.Column>
    </Grid.Row>
  );
};
export default ConnectedSubnets;
